import { T_ResourceCache } from '@cgs/wge';
import { CustomGamesResourceCache } from '@cgs/common';
import { ApplicationGameConfig } from '@cgs/shared';
import { TrifectaHudModule } from '@cgs/provider-trifecta';

export class SantaHudSdkModule extends TrifectaHudModule {
  public override async initialize(): Promise<void> {
    await this.loadPackage();
    await super.initialize();
  }

  // TrifectaGameRules/TrifectaGameHelp читают сцены из bottom.wad, которое под SDK никто больше не грузит
  private async loadPackage(): Promise<void> {
    const gameResourceCache = this.container.resolve<CustomGamesResourceCache>(T_ResourceCache);

    try {
      await gameResourceCache.loadPackage(`games/${ApplicationGameConfig.gameId}/bottom.zip`);
    } catch (error) {
      throw Error('Failed to load bottom.zip');
    }
  }
}
